import { isFuture } from "date-fns";

export const bookingSubscriptionLevels = ["Trial", "Subscription level 3"];

export const bookingDateFields = [
	"bookingdate",
	"confirmeddate",
	"confirmeddeadline",
	"created",
	"requesteddate",
	"responsedate",
	"responsedeadline",
	"updated"
];

export const declineReasons = [
	"Consumer could not be contacted",
	"Consumer selected another provider",
	"Location was not suitable",
	"No vacancies are available",
	"Not accepting admissions",
	"One or more care requirements can’t be met",
	"There is an extenuating circumstance",
	"Other"
];

export const cancelReasons = [
	"Consumer could not be contacted",
	"Consumer selected another provider",
	"Location was not suitable",
	"No vacancies are available",
	"Not accepting admissions",
	"Our hospital admissions status has changed",
	"There is an extenuating circumstance",
	"We can’t accommodate this person’s needs",
	"We can’t provide one or more care requirements",
	"We no longer have this vacancy available",
	"Other"
];

export const consentMethod = [
	{ value: "sms", label: "Replying to an SMS message" },
	{ value: "website", label: "Clicking a website link sent by email" },
	{ value: "printed-form", label: "Signing a printed form" }
];

export const consentProvider = [
	{ value: "social-worker", label: "Myself" },
	{ value: "patient", label: "Patient" },
	{ value: "patients-rep", label: "Patient's representative" }
];

export const detailDateFields = ["consentdate", "created", "updated"];

export const incomeAndAssets = [
	{ value: "not-yet-confirmed", label: "Not yet confirmed" },
	{ value: "non-pensioner", label: "Non-pensioner" },
	{ value: "pensioner-with-property", label: "Pensioner who owns property" },
	{ value: "pensioner-without-property", label: "Pensioner without property" }
];

export const meetingType = [
	{ value: "in-person", label: "In-person" },
	{ value: "video", label: "Video call" }
];

export const sharePatientDetails = [
	{ value: true, label: "Yes" },
	{ value: false, label: "No" }
];

export const relationships = [
	"Child",
	"Friend",
	"Immediate family member",
	"Legal Guardian",
	"Power of Attorney",
	"Spouse",
	"Other"
];

export const representativeStatus = [
	{
		value: "regular",
		label: "Regular representative",
		description:
			"Has consent to speak and act on behalf of the person who needs care"
	},
	{
		value: "authorised",
		label: "Authorised representative",
		description: "Can legally manage the affairs of the person who needs care"
	}
];

export const whatsNext = {
	provided: {
		content:
			"We’ll immediately release the request to the selected aged care facilities.",
		panel: null
	},
	website: {
		content:
			"First, we’ll send an email to the patient’s representative with a link to view a web page with the details from this form. There, they can click to consent to release their personal information to the aged care facilities.",
		panel:
			"We’ll ask facilities to accept the request within 12 business hours, and to contact the patient’s representative and confirm the request within the next seven days."
	},
	sms: {
		content:
			"First, we’ll send an SMS message to the patient’s representative with a website link to view the details from this form. There, they can click to consent to release their personal information to the aged care facilities.",
		panel:
			"We’ll ask facilities to accept your request within 12 business hours, and to contact the patient’s representative and confirm the request within the next seven days."
	},
	"printed-form": {
		content:
			"You can save the details of this form to send to aged care facilities. You’ll need to manually add the same information to the blank printed form for the patient’s representative to sign.",
		panel:
			"We’ll ask facilities to accept your request within 12 business hours, and to contact the patient’s representative and confirm the request within the next seven days."
	}
};

export const createOptions = {
	consentMethod,
	consentProvider,
	incomeAndAssets,
	meetingType,
	relationships,
	representativeStatus,
	sharePatientDetails,
	whatsNext
};

export const upcomingRule = (items, dateField = "bookingdate") => {
	return items.filter((item) => {
		return (
			["requested", "accepted"].includes(item.status) ||
			(item.status === "confirmed" &&
				item[dateField] &&
				isFuture(item[dateField]))
		);
	});
};

export const statuses = {
	accepted: "Acknowledged",
	complete: "Completed",
	requested: "Requested",
	cancelled: "Cancelled",
	confirmed: "Confirmed",
	declined: "Declined",
	expired: "Expired",
	pending: "Pending"
};

export default {
	bookinglistings: [],
	carefirstname: "",
	carelastname: null,
	centrelinkformcomplete: false,
	consentmethod: "sms",
	consentprovided: false,
	consentprovider: "patients-rep",
	email: null,
	firstname: null,
	incomeandassets: "not-yet-confirmed",
	lastname: null,
	listings: [],
	listingids: [],
	meetingtype: "in-person",
	message: null,
	mobile: null,
	preferredtime: null,
	relationship: null,
	representativestatus: "regular",
	responsemessage: null,
	sharepatientdetails: true,
	supportplanreference: null,
	type: "site-tour",
	sitehospitalid: 0,
	contactids: null,
	location: null,
	users: []
};
